<template>
    <!-- 数据分析 -->
    <div style="background: #FFFFFF">
        <div>
            <img class="top_img1" src="../../assets/img/shujufenxi.jpeg" />
        </div>
        <div style="margin-top: 50px;">
            <contentIndex :initInfo="info"></contentIndex>
        </div>
    </div>
</template>
<script>
import contentIndex from "./index.vue"
export default {
    components: {
        contentIndex
    },
    data() {
        return {
            info: {
                type: 8,
                testTypeList: [],
            }
        }
    }
}
</script>
<style scoped lang="scss">
.content_body{
    width: 100%;
    background: #FFFFFF;
    display: flex;
    justify-content: center;
    margin-top: 180px;
    padding-bottom: 180px;
    img{
        min-width: 980px;
        max-width: 80%;
        height: 100%;
    }
}
.content{
    width: 352px;
    // margin: 0 auto;
    text-align: center;
    
}
</style>